/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class AccountingPermissionKey {
  static readonly RECORD = 'accounting/permission/record';
}
